<template>
  <div class="student-rank-topBar">
    <div class="btn-list">
      <el-button @click="back" size="small">返回</el-button>
      <!-- 学生成绩排行 -->
      <el-button type="success" size="small" @click="derivedScore" v-hasPermi="'sc:graderank:export'"
        v-show="tabSelectName === 'first'">导出成绩</el-button>
      <el-button type="danger" size="small" @click="delScore" v-hasPermi="'sc:score:delete'"
        v-show="tabSelectName === 'first'">删除成绩</el-button>
      <el-button v-hasPermi="'sc:studentscorecomparison:export'" v-show="tabSelectName === 'first'" type="primary"
        v-if="examType == 'class'" size="small" @click="chartDialogShow">学生成绩对比</el-button>
      <!-- 各班成绩统计 -->
      <el-button type="success" size="small" v-show="tabSelectName !== 'first' && canShowButton()"
        @click="deriveClick">导出</el-button>
      <!-- 总分分布 -->
      <el-button type="success" size="small" v-show="tabSelectName === 'third'"
        @click="viewDialogShow('third')">查看视图</el-button>
      <!-- 各科成绩分析 -->
      <el-button type="success" size="small" v-show="tabSelectName === 'fourth'"
        @click="viewDialogShow('fourth-score')">查看分数视图</el-button>
      <el-button type="success" size="small" v-show="tabSelectName === 'fourth'"
        @click="viewDialogShow('fourth-index')">查看指标视图</el-button>
      <!-- 单科排名 -->
      <!-- <el-button type="success" size="small" v-show="tabSelectName === 'fifth'">查看视图</el-button> -->
      <!-- 各班排名 -->
      <el-button type="success" size="small" v-show="tabSelectName === 'sixth'"
        @click="viewDialogShow('sixth')">查看视图</el-button>
      <!-- 年级排名 -->
      <el-button type="success" size="small" v-show="tabSelectName === 'seventh'"
        @click="viewDialogShow('seventh')">查看视图</el-button>
      <el-button type="success" size="small" v-show="tabSelectName === 'seventh'"
        @click="copyStudentNames">复制名字</el-button>
      <!-- <search :placeholder="'请输入学生姓名'" @search="studentSearch" />
      <search :placeholder="'请输入学号'" @search="studentNumberSearch" /> -->
    </div>
    <!-- 总分分布 -->
    <div class="total-score" v-show="tabSelectName === 'third'">
      <div class="grade-rank-enter total-score-item">
        <el-input type="number" v-model="totalScoreData.fractionalIntervalVal" min="1" placeholder="请输入分数间隔">
        </el-input>
      </div>
      <div class="grade-rank-enter total-score-item">
        <el-input type="number" v-model="totalScoreData.cutoffScoreVal" min="1" placeholder="请输入截止分数">
          <!-- <el-button slot="append" icon="el-icon-search" @click="courseRankSearch"></el-button> -->
        </el-input>
      </div>
      <el-button type="primary" icon="el-icon-search" @click="totalScoreDistributionSearch"></el-button>
    </div>
    <!-- 单科排名名次录入 -->
    <div class="grade-rank-enter" v-show="tabSelectName === 'fifth'">
      <el-input type="number" v-model="courseRankVal" min="1" placeholder="请输入名次"
        @keyup.enter.native="courseRankSearch">
        <el-button slot="append" icon="el-icon-search" @click="courseRankSearch"></el-button>
      </el-input>
    </div>
    <!-- 各班排名名次录入 -->
    <div class="grade-rank-enter" v-show="tabSelectName === 'sixth'">
      <el-input type="number" v-model="classRankVal" min="1" placeholder="请输入名次" @keyup.enter.native="classRankSearch">
        <el-button slot="append" icon="el-icon-search" @click="classRankSearch"></el-button>
      </el-input>
    </div>
    <!-- 年级排名名次录入 -->
    <div class="grade-rank-enter" v-show="tabSelectName === 'seventh'">
      <el-input type="number" v-model="gradeRankVal" min="1" placeholder="请输入名次" @keyup.enter.native="gradeRankSearch">
        <el-button slot="append" icon="el-icon-search" @click="gradeRankSearch"></el-button>
      </el-input>
    </div>
    <div class="color-list" v-show="tabSelectName === 'first'">
      <div class="color-item">
        科目成绩：
        <div class="color-box" :style="{ backgroundColor: color1 }"></div>
      </div>
      <div class="color-item">
        班级排名：
        <div class="color-box" :style="{ backgroundColor: color2 }"></div>
      </div>
      <div class="color-item">
        年级排名：
        <div class="color-box" :style="{ backgroundColor: color3 }"></div>
      </div>
    </div>
    <div class="select-list" v-show="tabSelectName === 'first'">
      <el-select v-model="selectCourseList" multiple placeholder="请选择对比科目" @change="selectCourse" size="small">
        <el-option v-for="item in courseList" :key="item.courseId" :label="item.courseName" :value="item.courseId">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { baseURL } from "@/api/request"; // 服务器地址
import search from "@/components/search/search.vue";
export default {
  props: ["classAverageScoreList", "standardGapList", "studentCourseSuperAverageList", "gradeRankStudentList", "classRankStudentList", "examType", "studentList", "courseList", "tabSelectName", "examInfo", "classStatisticsData", "totalScoreDistributionList", "courseScoreAnalysisList", "courseRankStudentList"],
  components: { search },
  data() {
    return {
      selectCourseList: [], // 选中的科目
      color1: "#e21918",
      color2: "#0066cc",
      color3: "#008000",
      gradeRankVal: "", // 年级排名输入框
      courseRankVal: "", // 单科排名输入框
      classRankVal: "", // 班级排名输入框
      totalScoreData: {
        fractionalIntervalVal: "", // 总分分布-分数间隔
        cutoffScoreVal: "", // 总分分布-截止分数
      },
      menuPermissions: null, // 菜单权限
      permissionFieldList: [{ // 按钮权限列表
        name: 'second',
        permissionField: 'sc:classscore:statistics:export'
      }, {
        name: 'third',
        permissionField: 'sc:totalscore:distribution:export'
      }, {
        name: 'fourth',
        permissionField: 'sc:course:analysis:export'
      }, {
        name: 'fifth',
        permissionField: 'sc:singlesubject:ranking:export'
      }, {
        name: 'sixth',
        permissionField: 'sc:classranking:export'
      }, {
        name: 'seventh',
        permissionField: 'sc:graderanking:export'
      }, {
        name: 'eighth',
        permissionField: 'sc:coursekpi:export'
      }, {
        name: 'ninth',
        permissionField: 'sc:coursekpi:export'
      }, {
        name: 'tenth',
        permissionField: 'sc:coursekpi:export'
      }]
    };
  },
  methods: {
    // 学生排行-删除成绩
    delScore() {
      this.$emit('delScore');
    },
    // 按钮权限判断
    hasPermission(permissionField) {
      if (!this.menuPermissions) {
        const permissions = window.localStorage.getItem("menuPermissions");
        this.menuPermissions = permissions ? permissions.split(',') : [];
      }
      return this.menuPermissions.includes(permissionField);
    },
    canShowButton() {
      // 检查是否有权限显示按钮
      return this.hasPermission(this.permissionFieldList.find(item => item.name === this.tabSelectName).permissionField);
    },
    // 导出点击
    deriveClick() {
      let action;
      // 年级名次排行
      if (this.tabSelectName === 'seventh') {
        if (!this.gradeRankVal) return this.$message.warning("请输入名次");
        if (!this.gradeRankStudentList || this.gradeRankStudentList.length == 0) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.exportPreGradeRank}?examInfoId=${this.examInfo.id}&rank=${this.gradeRankVal}`;
      };
      // 班级名次排行
      if (this.tabSelectName === 'sixth') {
        if (!this.classRankVal) return this.$message.warning("请输入名次");
        if (!this.classRankStudentList || this.classRankStudentList.length == 0) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.exportPreClassRank}?examInfoId=${this.examInfo.id}&rank=${this.classRankVal}`;
      };
      // 单科名次排行
      if (this.tabSelectName === 'fifth') {
        if (!this.courseRankVal) return this.$message.warning("请输入名次");
        if (!this.courseRankStudentList || this.courseRankStudentList.length == 0) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.exportPreCourseRank}?examInfoId=${this.examInfo.id}&rank=${this.courseRankVal}`;
      };
      // 各科成绩分析
      if (this.tabSelectName === 'fourth') {
        if (!this.courseScoreAnalysisList || this.courseScoreAnalysisList.length == 0) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.exportAnalysisEachSubject}?examInfoId=${this.examInfo.id}`;
      };
      // 总分分布
      if (this.tabSelectName === 'third') {
        if (this.totalScoreData.fractionalIntervalVal == '' || this.totalScoreData.cutoffScoreVal == '') return this.$message.warning("请输入分数间隔和截止分数");
        if (!this.totalScoreDistributionList || this.totalScoreDistributionList.length == 0 || !this.totalScoreDistributionList.some(
          ({ branchSegments }) =>
            branchSegments &&
            typeof branchSegments === 'object' &&
            Object.keys(branchSegments).length > 0
        )) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.exportTotalScoreComparison}?examInfoId=${this.examInfo.id}&intervalScore=${this.totalScoreData.fractionalIntervalVal}&abortScore=${this.totalScoreData.cutoffScoreVal}`;
      };
      // 各班成绩统计
      if (this.tabSelectName === 'second') {
        if (!this.classStatisticsData || this.classStatisticsData.length == 0 || !this.classStatisticsData.some(item => item.courseAnalysis.length != 0)) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.exportEachClassStatistics}?examInfoId=${this.examInfo.id}`;
      };
      // 平均分
      if (this.tabSelectName === 'eighth') {
        if (!this.classAverageScoreList || this.classAverageScoreList.length == 0) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.averageScoreExcelDownload}/${this.examInfo.id}`;
      };
      // 超均率
      if (this.tabSelectName === 'ninth') {
        if (!this.studentCourseSuperAverageList || this.studentCourseSuperAverageList.length == 0) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.superAverageExcelDownload}/${this.examInfo.id}`;
      };
      // 标准差
      if (this.tabSelectName === 'tenth') {
        if (!this.standardGapList || this.standardGapList.length == 0) return this.$message.warning("暂无成绩");
        action = `${baseURL}${this.$url.standardDeviationExcelDownload}/${this.examInfo.id}`;
      };
      this.$downloadFile(action);
    },
    // 查看视图点击
    viewDialogShow(tagName) {
      // 判断是否已经输入名次
      if (tagName == 'third') {
        if (this.totalScoreData.fractionalIntervalVal == '' || this.totalScoreData.cutoffScoreVal == '') return this.$message.warning("请输入分数间隔和截止分数");
      } else if (tagName == 'sixth') {
        if (!this.classRankVal) return this.$message.warning("请输入名次");
      } else if (tagName == 'seventh') {
        if (!this.gradeRankVal) return this.$message.warning("请输入名次");
      };
      this.$emit("viewDialogShowChange", tagName);
    },
    // 总分分布搜索
    totalScoreDistributionSearch() {
      if (this.totalScoreData.fractionalIntervalVal == '' || this.totalScoreData.cutoffScoreVal == '') return this.$message.warning("请输入分数间隔和截止分数");
      // 检测输入的是不是整数
      if (this.totalScoreData.fractionalIntervalVal.includes('.') || this.totalScoreData.cutoffScoreVal.includes('.')) {
        return this.$message.warning("只能输入整数数字");
      };
      this.$emit("totalScoreDistributionSearch", this.totalScoreData);
    },
    // 年级排名复制名字
    copyStudentNames() {
      this.$emit("copyStudentNames");
    },
    back() {
      this.$emit("back");
    },
    courseRankSearch() {
      if (!this.courseRankVal) return this.$message.warning("请输入名次");
      // 检测输入的是不是整数
      if (this.courseRankVal.includes('.')) {
        return this.$message.warning("只能输入整数数字");
      };
      this.$emit("courseRankSearch", this.courseRankVal);
    },
    classRankSearch() {
      if (!this.classRankVal) return this.$message.warning("请输入名次");
      // 检测输入的是不是整数
      if (this.classRankVal.includes('.')) {
        return this.$message.warning("只能输入整数数字");
      };
      this.$emit("classRankSearch", this.classRankVal);
    },
    gradeRankSearch() {
      // console.log(this.gradeRankVal);
      if (!this.gradeRankVal) return this.$message.warning("请输入名次");
      // 检测输入的是不是整数
      if (this.gradeRankVal.includes('.')) {
        return this.$message.warning("只能输入整数数字");
      };
      this.$emit("gradeRankSearch", this.gradeRankVal);
    },
    chartDialogShow() {
      this.$emit("chartDialogShow", true);
    },
    studentSearch(e) { },
    studentNumberSearch(e) { },
    selectCourse(e) {
      // console.log("选中的科目切换==>", e);
      this.$emit("selectCourseChange", e);
    },
    derivedScore() {
      if (!this.studentList || !this.studentList.length) return this.$message.warning("暂无成绩");
      this.$emit("derivedScore");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementAnalysisTopBar.scss";
</style>